module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary",
    attrs: {
      "id": "city-summary"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.flag
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v(_vm._s(_vm.city.City.country))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Region")]), _vm._v(" "), _c('div', {
    staticClass: "region"
  }, [_vm._v(_vm._s(_vm.city.Region.name))])]), _vm._v(" "), (_vm.sectionKey != 0) ? _c('div', [_c('div', {
    staticClass: "cursor",
    class: {
      open: _vm.dropdown
    },
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "more-title"
  }, [_vm._v("City Summary")])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "show-more"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Population")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.population))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Urban Extent")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.extent) + ' persons/hectare')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Density")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.density) + ' hectares')
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb4cee4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CitySummary.vue
// module id = 302
// module chunks = 1